import React from 'react';
import { Box, Typography, Paper, Container } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import PublicPageLayout from '../components/layout/PublicPageLayout';
import usePageTitle from '../hooks/usePageTitle';
import CanonicalLink from '../components/common/CanonicalLink';

const NotFoundPage: React.FC = () => {
  usePageTitle('Page Not Found (404) | WaveScoop');

  return (
    <PublicPageLayout>
      <Helmet>
        <title>Page Not Found (404) | WaveScoop</title>
        <meta name="description" content="The page you're looking for could not be found." />
      </Helmet>
      <CanonicalLink />

      <Container component="main" maxWidth="md" sx={{ py: {xs: 5, md: 8}, flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Paper 
          elevation={3} 
          sx={{
            p: { xs: 3, sm: 4, md: 6 },
            bgcolor: 'rgba(15, 51, 89, 0.75)', // Consistent with other pages
            backdropFilter: 'blur(8px)',
            border: '1px solid rgba(255, 255, 255, 0.15)',
            color: 'rgba(240, 240, 240, 0.95)',
            borderRadius: 2,
            textAlign: 'center'
          }}
        >
          <Typography variant="h1" component="h1" sx={{ mb: 2, fontSize: { xs: '2.8rem', sm: '3.5rem' }, fontWeight: 'bold' }}>
            Wave Wiped Out 🌊 (404)
          </Typography>
          <Typography variant="h5" component="p" sx={{ color: 'rgba(220, 220, 220, 0.9)', fontSize: { xs: '1.1rem', md: '1.25rem' } }}>
            The page you're looking for drifted out to sea.
          </Typography>
        </Paper>
      </Container>
    </PublicPageLayout>
  );
};

export default NotFoundPage; 